<template>
    <v-card>
        <ClTableSimple
            :headers="table.headers"
            :items="displayedDeliverableList"
            :noDataText="( !hasCurrentDestinationLocatorId ? 'Nothing is ready to be delivered.' : 'Nothing is ready to be delivered to this Destination.' )"
        >
            <template #[`item.scanned`]="{ item }">
                <v-icon>{{ item.scanned ? 'mdi-checkbox-marked-outline': 'mdi-checkbox-blank-outline' }}</v-icon>
            </template>
            <template #[`item.delivered`]="{ item }">
                <v-icon
                    v-if="item.scanned || ( item.scanned && !item.delivered )"
                    :color="getSavedIconColor( item )"
                >
                  {{ deliveredIconInfo( item, 'className' ) }}
                </v-icon>
            </template>
        </ClTableSimple>
    </v-card>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

export default {
    name: 'TableDeliverableItems',
    data() {
        return {
            table: {
                headers: [
                    {
                        text: 'Scanned',
                        value: 'scanned',
                    },
                    {
                        text: 'Type',
                        value: 'mailTypeFriendly',
                    },
                    {
                        text: 'Recipient',
                        value: 'customerFullName',
                    },
                    {
                        text: 'Tracking Number',
                        value: 'refNum',
                    },
                    {
                        text: 'Saved',
                        value: 'delivered',
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters( {
            hasCurrentDestinationLocatorId: 'Mail/Delivery/Current/hasCurrentDestinationLocatorId',
            displayedDeliverableList: 'Mail/Delivery/Current/displayedDeliverableList',
        } ),
    },
    methods: {
        /**
         * @params { Object } row
         * @params { String } type - an attribute in a deliveryStateMap object
         * @returns { String }
         */
        deliveredIconInfo( row, type ) {
            const deliveryStateMap = {
                'scanned-delivered': {
                    text: 'Delivered',
                    className: 'cloud-check',
                },
                'scanned-not-delivered': {
                    text: 'Scanned but not yet Delivered',
                    className: 'cloud-off-online',
                },
                'not-scanned-not-delivered': {
                    text: 'Not Delivered',
                    className: '',
                },
            };
            if ( row.scanned && row.delivered ) return deliveryStateMap[ 'scanned-delivered' ][ type ];
            if ( row.scanned && !row.delivered ) return deliveryStateMap[ 'scanned-not-delivered' ][ type ];
            return deliveryStateMap[ 'not-scanned-not-delivered' ][ type ];
        },

        /** @returns { Boolean } */
        textContainsError( text ) {
            return !!text
                && ( typeof text === 'string' )
                && text.toLowerCase().includes( 'error' );
        },

        /** @returns { String} */
        getSavedIconColor( item ) {
            if ( this.textContainsError( item ) ) {
                return 'error';
            }
            if ( item.delivered ) {
                return 'primary';
            }
            return '';
        },
    },
};
</script>

<style scoped lang="scss">
.empty-content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    padding: 1rem;
}

.error-text {
    color: darkred;
    font-weight: bold;
}
</style>
